/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable eqeqeq */
import React, { useEffect, useState } from 'react'
import { Snackbar } from '../../components/index'
import { AuthApi } from '../../api/auth'
export const Timer = (props) => {
  const [sec, setSec] = useState(59)
  const [min, seMin] = useState(props.start - 1)
  const [run, setRun] = useState(true)

  useEffect(() => {
    const timer = setTimeout(() => {
      if (sec === 0) {
        seMin(min - 1)
        setSec(59)
      } else {
        setSec(sec - 1)
      }
    }, 1000)
    if (sec == 0 && min == 0) {
      clearTimeout(timer)
      setRun(false)
    }
  }, [sec])

  const ResendCode = async () => {
    await AuthApi.sendCode(localStorage.getItem('userMobile'))
      .then((res) => {
        console.log(res.data)
      })
      .catch((err) => {
        Snackbar({
          title: 'نا موفق',
          message: err.response.data.errors[0].message,
          type: 'danger',
        })
      })
  }

  const AgainOpt = () => {
    ResendCode()
    setRun(true)
    seMin(props.start - 1)
    setSec(59)
  }

  return (
    <>
      {run ? (
        <span>
          {String(min).padStart(2, 0)}:{String(sec).padStart(2, 0)}
        </span>
      ) : (
        <span className='timer-btn' onClick={() => AgainOpt()}>
          ارسال مجدد
        </span>
      )}
    </>
  )
}

export default Timer
